import {Select} from '@mantine/core';
import {useForm, zodResolver} from '@mantine/form';
import type {NextPage} from 'next';
import {useEffect, useState} from 'react';
import {MdSearch} from 'react-icons/md';
import * as z from 'zod';
import {
  type QuestionOrderType,
  questionOrderType,
} from '../../../core/entities/box/constants';

type Props = {
  placeholder: string;
  setSearchWords: React.Dispatch<React.SetStateAction<string>>;
  setQuestionOrderType: React.Dispatch<React.SetStateAction<QuestionOrderType>>;
};

const SearchFormInput = z.object({
  q: z.string(),
});
type SearchFormInput = z.infer<typeof SearchFormInput>;

export const SearchForm: NextPage<Props> = ({
  placeholder,
  setSearchWords,
  setQuestionOrderType,
}) => {
  const [searchResultOrder, setSearchResultOrder] = useState<QuestionOrderType>(
    questionOrderType.recommend,
  );
  const [isShowOederSelectBox, setIsShowOederSelectBox] =
    useState<boolean>(false);
  const form = useForm<SearchFormInput>({
    initialValues: {
      q: '',
    },
    validate: zodResolver(SearchFormInput),
  });

  const onSubmit = (input: SearchFormInput): {q: string} => {
    setSearchWords(input.q);
    if (input.q === '') {
      setQuestionOrderType(questionOrderType.answeredAt);
      setIsShowOederSelectBox(false);
    } else {
      setQuestionOrderType(searchResultOrder);
      setIsShowOederSelectBox(true);
    }

    return {
      q: input.q,
    };
  };

  const onError = () => {
    // TODO: error handling
    alert('エラーが発生しました');
  };

  useEffect(() => {
    setQuestionOrderType(searchResultOrder);
  }, [searchResultOrder, setQuestionOrderType]);

  return (
    <>
      <form
        onSubmit={form.onSubmit(onSubmit, onError)}
        className="flex h-[45px] items-center rounded-full bg-background-1 px-16"
      >
        <i className="mr-8">
          <MdSearch size="11" color="#1E6A93" />
        </i>

        <input
          id="q"
          {...form.getInputProps('q')}
          className="w-full bg-transparent focus:bg-transparent"
          placeholder={placeholder}
          autoComplete="off"
        />
      </form>
      {isShowOederSelectBox && (
        <OrderSelectBox
          searchResultOrder={searchResultOrder}
          setOrderWithSearchWords={setSearchResultOrder}
        />
      )}
    </>
  );
};

const OrderSelectBox: React.FC<{
  searchResultOrder: QuestionOrderType;
  setOrderWithSearchWords: React.Dispatch<
    React.SetStateAction<QuestionOrderType>
  >;
}> = ({searchResultOrder, setOrderWithSearchWords}) => {
  const options = [
    {
      label: '関連度順',
      value: questionOrderType.recommend,
    },
    {
      label: '新着順',
      value: questionOrderType.answeredAt,
    },
  ];

  const handleChange = (newValue: QuestionOrderType) => {
    if (newValue) {
      setOrderWithSearchWords(newValue);
    }
  };

  return (
    <div className="mt-16 flex justify-end">
      <Select
        defaultValue={searchResultOrder}
        onChange={handleChange}
        data={options}
        styles={{
          input: {
            fontSize: '14px',
            height: '24px',
            width: '150px',
          },
        }}
      />
    </div>
  );
};
